import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { auth } from "../services/api";
import yandexLogo from "../assets/logo.png";

const LoginPage = ({ onLogin }) => {

    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        email: "",
        password: ""
    });

    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {

        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });

    };

    const handleYandexLogin = async () => {

        try {

            const response = await auth.yandexLogin();

            window.location.href = response.data.auth_url;

        } catch {

            setError("Ошибка входа через Яндекс");

        }

    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        setLoading(true);
        setError("");

        try {

            const response = await auth.login(formData);

            const { access_token } = response.data;

            localStorage.setItem("token", access_token);

            const userResponse = await auth.getMe();

            localStorage.setItem("user", JSON.stringify(userResponse.data));

            onLogin(userResponse.data, access_token);

            navigate("/");

        } catch (err) {

            const detail = err.response?.data?.detail;

            if (Array.isArray(detail)) {
                setError(detail[0].msg);
            } else {
                setError(detail || "Ошибка входа");
            }

        } finally {

            setLoading(false);

        }

    };

    return (

        <div className="auth-wrapper">

            <div className="auth-card">

                <h2 className="auth-title">Вход</h2>

                {error && <div className="error">{error}</div>}

                <form className="auth-form" onSubmit={handleSubmit}>

                    <input
                        type="email"
                        name="email"
                        className="form-input"
                        placeholder="Email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                    />

                    <input
                        type="password"
                        name="password"
                        className="form-input"
                        placeholder="Пароль"
                        value={formData.password}
                        onChange={handleChange}
                        required
                    />

                    <button
                        type="submit"
                        className="btn-primary"
                        disabled={loading}
                    >
                        {loading ? "Вход..." : "Войти"}
                    </button>

                </form>

                <div className="divider">
                    <span>или</span>
                </div>

                <button
                    type="button"
                    className="yandex-btn"
                    onClick={handleYandexLogin}
                >
                    <img src={yandexLogo} alt="Yandex" className="yandex-icon" />
                    Войти через Яндекс
                </button>

                <div className="auth-link">
                    Нет аккаунта? <Link to="/register">Зарегистрироваться</Link>
                </div>

            </div>

        </div>

    );

};

export default LoginPage;